export const blobToBase64 = (blob: Blob) => {
  return new Promise<string>(resolve => {
    const reader = new FileReader();
    reader.onload = () => resolve((reader.result as string).split(",")[1]);
    reader.readAsDataURL(blob);
  });
};
